import { render, staticRenderFns } from "./MemberStatisticsInfo.vue?vue&type=template&id=2c4dc24e&scoped=true"
import script from "./MemberStatisticsInfo.vue?vue&type=script&lang=js"
export * from "./MemberStatisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberStatisticsInfo.vue?vue&type=style&index=0&id=2c4dc24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4dc24e",
  null
  
)

export default component.exports